import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class TrackingStore extends EventDrivenStore {
  constructor() {
    super('tracking', {
      loading: false,
      error: null,
      data: null,
      type: null, // 'order' | 'package'
      code: null,
    });
  }

  setupEvents() {
    // Loading events
    this.on(constants.EVENTS.TRACKING.BY_CODE, () => {
      this.state.loading = true;
      this.state.error = null;
    });

    // Data loaded event
    this.on(constants.EVENTS.TRACKING.LOADED, (data) => {
      this.state.data = data;
      this.state.loading = false;
      this.state.error = null;
    });

    // Error event
    this.on(constants.EVENTS.TRACKING.ERROR, (error) => {
      this.state.error = error;
      this.state.loading = false;
      this.state.data = null;
    });

    // Update type and code when tracking
    this.on(constants.EVENTS.TRACKING.LOADED, (data) => {
      // Keep tracking data synced
    });
  }

  // Getters
  get isLoading() {
    return this.state.loading;
  }

  get hasError() {
    return this.state.error !== null;
  }

  get errorMessage() {
    return this.state.error;
  }

  get trackingData() {
    return this.state.data;
  }

  get trackingType() {
    return this.state.type;
  }

  get trackingCode() {
    return this.state.code;
  }

  get status() {
    return this.state.data?.status || null;
  }

  get reference() {
    return this.state.data?.reference || null;
  }

  get pickupAddress() {
    return this.state.data?.pickupAddress || null;
  }

  get deliveryAddress() {
    return this.state.data?.deliveryAddress || this.state.data?.destinationAddress || null;
  }

  get timeline() {
    return this.state.data?.timeline || this.state.data?.stepsTimeline || [];
  }

  get times() {
    return this.state.data?.times || {};
  }

  // Actions
  setTrackingType(type) {
    this.state.type = type;
  }

  setTrackingCode(code) {
    this.state.code = code;
  }

  reset() {
    this.state.loading = false;
    this.state.error = null;
    this.state.data = null;
    this.state.type = null;
    this.state.code = null;
  }
}

export default TrackingStore;
